"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessUpdateUserBodyToJSON = exports.BusinessUpdateUserBodyFromJSONTyped = exports.BusinessUpdateUserBodyFromJSON = void 0;
var _1 = require("./");
function BusinessUpdateUserBodyFromJSON(json) {
    return BusinessUpdateUserBodyFromJSONTyped(json, false);
}
exports.BusinessUpdateUserBodyFromJSON = BusinessUpdateUserBodyFromJSON;
function BusinessUpdateUserBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'permissions': (json['permissions'].map(_1.BusinessPermissionFromJSON)),
    };
}
exports.BusinessUpdateUserBodyFromJSONTyped = BusinessUpdateUserBodyFromJSONTyped;
function BusinessUpdateUserBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'permissions': (value.permissions.map(_1.BusinessPermissionToJSON)),
    };
}
exports.BusinessUpdateUserBodyToJSON = BusinessUpdateUserBodyToJSON;
